// import React from 'react';

// import { WithChildrenProps } from '@app/types/generalTypes';

// const RequireAuth: React.FC<WithChildrenProps> = ({ children }) => {

//   return <>{children}</>;
// };

// export default RequireAuth;

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '@app/hooks/reduxHooks';
import { WithChildrenProps } from '@app/types/generalTypes';
import { isLocationProtected } from '@app/utils/roles';

const RequireAuth: React.FC<WithChildrenProps> = ({ children }) => {
  let token = useAppSelector((state) => state.auth?.token?.token);
  const isFirstTImeUser = useAppSelector((state) => state.auth.token?.isFirstTimeLogin);
  if (isFirstTImeUser) {
    token = '';
  }

  const location = useLocation();
  const allowedpages = useAppSelector((state) => state.user.user?.AllowedPages);
  if (allowedpages) {
    const isLocationrestricted = isLocationProtected(location.pathname, allowedpages);
    if (!isLocationrestricted) {
      return <Navigate to="/error/invalidroute" replace />;
    }
  }
  return token ? <>{children}</> : <Navigate to="/auth/login" replace />;
};

export default RequireAuth;
